if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) { this.hideTab(); return; }
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }


    hideTab() { const panel = this.closest('.product__tab-content'); if (!panel) return; panel.classList.add('hidden'); const tabsRoot = this.closest('product-tabs'); if (!tabsRoot) return; const tabButton = tabsRoot.querySelector(`.product__tab--trigger[data-tab="${panel.id}"]`); if (!tabButton) return; const wasActiveOrDefault = tabButton.classList.contains('active') || tabButton.hasAttribute('data-default-open'); tabButton.classList.add('hidden'); if (!wasActiveOrDefault) return; const nextTab = tabsRoot.querySelector('.product__tab--trigger:not(.hidden)'); if (nextTab) { nextTab.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })); } else { const block = tabsRoot.closest('.product-complementaries-block'); if (block) block.classList.add('hidden'); } }
    initSlider() {
      const swiperOptions = JSON.parse(this.dataset.swiperOptions || '{}');

      const options = {
        slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
        spaceBetween: swiperOptions.spaceBetweenMobile || 16,
      };

      if (swiperOptions.slidesPerViewTablet || swiperOptions.slidesPerViewDesktop) {
        options.breakpoints = {};
        if (swiperOptions.slidesPerViewTablet) {
          options.breakpoints[swiperOptions.breakpointTablet || 750] = {
            slidesPerView: swiperOptions.slidesPerViewTablet,
            spaceBetween: swiperOptions.spaceBetweenDesktop || options.spaceBetween
          };
        }
        if (swiperOptions.slidesPerViewDesktop) {
          options.breakpoints[swiperOptions.breakpointDesktop || 1100] = {
            slidesPerView: swiperOptions.slidesPerViewDesktop,
            spaceBetween: swiperOptions.spaceBetweenDesktop || options.spaceBetween
          };
        }
      }

      const scrollbarEl = this.querySelector('.swiper-scrollbar');
      if (scrollbarEl) {
        options.scrollbar = {
          el: scrollbarEl,
          draggable: true,
          hide: false
        };
      }

      const prevEl = this.querySelector('.product-recommendations__nav-prev');
      const nextEl = this.querySelector('.product-recommendations__nav-next');
      if (prevEl && nextEl) {
        options.navigation = { prevEl, nextEl };
      }

      this.slider = new Swiper(this.querySelector('.swiper'), options);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
